import { useEffect } from 'react'
import useAuthPatient from 'src/Patient/hooks/useAuthPatient';

const VerifyPatientRegister = () => {
    const { autoLogoutWhenExpiredToken, getDetailPatient } = useAuthPatient();

    useEffect(() => {
        getDetailPatient();
        autoLogoutWhenExpiredToken()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default VerifyPatientRegister
